// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"a0f8773b","44":"fd0ec083","319":"c48b616d","703":"fed6da10","945":"0524822c"}[chunkId] + ".js";
};